/**
 * Singleton Supabase Client
 *
 * Ensures single client instance across the application to prevent
 * duplicate auth listeners and request floods.
 *
 * Import like this:
 * import { supabase } from '@/lib/supabaseClient';
 */

import { supabase as supabaseClient } from '@/integrations/supabase/client';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

// Module-level guard to enforce singleton
let singletonInstance: SupabaseClient<Database> | null = null;

// Export singleton client instance with enforcement
export const supabase: SupabaseClient<Database> = (() => {
  if (!singletonInstance) {
    singletonInstance = supabaseClient;
  }
  return singletonInstance;
})();
